export const images = [
    {
      id: '01',
      src: '/rain tree 01.jpeg',
      alt: 'Whitney',
    },
    {
      id: '02',
      src: '/rain tree 02.jpeg',
      alt: 'Whitney',
    },
    {
      id: '03',
      src: '/rain tree 03.jpg',
      alt: 'Whitney',
    },
    {
      id: '04',
      src: '/rain tree 04.jpg',
      alt: 'Whitney',
    },
    {
        id: '04',
        src: '/rain tree 05.jpg',
        alt: 'Whitney',
      },
      {
        id: '04',
        src: '/rain tree 06.jpg',
        alt: 'Whitney',
      },
      {
        id: '04',
        src: '/rain tree 07.jpeg',
        alt: 'Whitney',
      },
      {
        id: '04',
        src: '/rain tree 08.jpg',
        alt: 'Whitney',
      },  
      {
        id: '04',
        src: '/rain tree 09.jpg',
        alt: 'Whitney',
      },  
      {
        id: '04',
        src: '/rain tree 10.jpg',
        alt: 'Whitney',
      },
      {
        id: '04',
        src: '/rain tree 11.jpg',
        alt: 'Whitney',
      },            
  ]